import React from 'react';

// Compact filter summary shown while searching (prototype-styled muted mono line).
const SearchResults = ({ searchQuery, controlCount, ttpCount }) => {
  if (!searchQuery.trim()) return null;
  return (
    <div className="tv-hint" style={{ fontFamily: 'var(--font-mono)', marginBottom: 14 }}>
      Filter “{searchQuery}” · {controlCount} controls · {ttpCount} techniques
    </div>
  );
};

export default SearchResults;
